export const MASK = {
  short: 's',
  medium: 'm',
  wide: 'w',
  'to-right': 'tr',
  'to-left': 'tl'
}
